module.exports = "/virtual-football-league/img/amblems/right/logos/Lyon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Lyon.png
// module id = 2212
// module chunks = 4